module.exports = __webpack_public_path__ + "img/e4db5ab3aa06ac3af883f6a88f2fac5b.png";